import axios from 'axios'

//export default function ({ store, redirect, route, app }) {
export default defineNuxtRouteMiddleware((to) => {

    
    const stateUser = useState('user', () => ({id: 0}))
    const stateApp = useState('app', () => ({}))
    const stateInitialized = useState('initialized')

    

    stateInitialized.value = false
    return axios.get('/be/user/get', { params: { path: to.path } }).then((res) => {
        const { $i18n } = useNuxtApp();
        $i18n.locale.value = res.data.lang
        if (res.data.id) {
            stateUser.value = res.data
            localStorage.setItem('user', JSON.stringify(res.data))
            
            if (!res.data.public && to.path === '/' && !to.path.match(/^\/passwordReset/)) {
                return navigateTo('/dashboard')
            }
        } else if (!to.path.match(/^\/passwordReset/) && !to.path.match(/^\/be\/openid\/login/)) {
            if (res.data.openid) {
                // docasne pre demonstraciu openid
                if (to.query.code) {
                    window.location.href = `/be/openid/login?code=${to.query.code}&state=${to.query.state}`
                    return
                } else {
                    window.location.href = '/be/openid/login'
                    return
                }
            } else if (!res.data.public && to.path !== '/' && !to.path.match(/^\/event\//)) {
                return navigateTo('/?url=' + to.path, { redirectCode: 307 })
            }
        }
        stateInitialized.value = true
        axios.get('/be/appData').then((res) => {
            stateApp.value = res.data
        })
    })
})
